__turbopack_context__.v({
  "className": "dm_sans_81a33cc5-module___RQdfW__className",
  "variable": "dm_sans_81a33cc5-module___RQdfW__variable",
});
